/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AccordionList from '../components/AccordionList';
import AccordionMultiplePDF from '../components/AccordionMultiplePDF';
import Advisor from '../components/Advisor';
import BrandPortfolio from '../components/BrandPortfolio';
import Breadcrumb from '../components/Breadcrumb';
import CardCarousel from '../components/CardCarousel';
import CardGrid from '../components/CardGrid';
import CardGridContacts from '../components/CardGridContacts';
import CardLink from '../components/CardLink';
import CardList from '../components/CardList';
import CardListExtra from '../components/CardListExtra';
import CardModuleFull from '../components/CardModuleFull';
import CarouselCardHighlights from '../components/CarouselCardHighlights';
import CollapsibleTextModule from '../components/CollapsibleTextModule';
import ColumnCard from '../components/ColumnCard';
import ContactCards from '../components/ContactCards';
import ContentHubSeriesDetails from '../components/ContentHubSeriesDetails';
import ContentHubSeriesOverview from '../components/ContentHubSeriesOverview';
import ContentHubSpecialOffers from '../components/ContentHubSpecialOffers';
import CookiePolicyBanner from '../components/CookiePolicyBanner';
import CustomHtmlComponent from '../components/CustomHtmlComponent';
import DataTableCNHComponent from '../components/DataTableCNHComponent';
import Disclaimer from '../components/Disclaimer';
import DownloadList from '../components/DownloadList';
import DropDown from '../components/DropDown';
import Events from '../components/Events';
import ExploreEquipment from '../components/ExploreEquipment';
import ExternalComponent from '../components/ExternalComponent';
import FindADealer from '../components/FindADealer';
import Footer from '../components/Footer';
import GenericCTAList from '../components/GenericCTAList';
import Header from '../components/Header';
import HeroBanner from '../components/HeroBanner';
import HeroCarousel from '../components/HeroCarousel';
import Highlights from '../components/Highlights';
import HistoryModule from '../components/HistoryModule';
import IconButton from '../components/IconButton';
import IFrame from '../components/IFrame';
import KeepInTouch from '../components/KeepInTouch';
import LanguageDropdown from '../components/LanguageDropdown';
import LanguageSelector from '../components/LanguageSelector';
import LightWeightHeader from '../components/LightWeightHeader';
import LinkList from '../components/LinkList';
import ModelsListing from '../components/ModelsListing';
import NavigationFilterCardList from '../components/NavigationFilterCardList';
import NavigationLinkList from '../components/NavigationLinkList';
import NewsletterConfirmation from '../components/NewsletterConfirmation';
import PageTitle from '../components/PageTitle';
import PrivacyBanner from '../components/PrivacyBanner';
import PrivacyBottomBanner from '../components/PrivacyBottomBanner';
import PrivacyFilter from '../components/PrivacyFilter';
import PrivacyForm from '../components/PrivacyForm';
import PrivacyStatement from '../components/PrivacyStatement';
import PrivacyStatementV2 from '../components/PrivacyStatementV2';
import ProductIntro from '../components/ProductIntro';
import Redirectww1Component from '../components/Redirectww1Component';
import RelatedLinks from '../components/RelatedLinks';
import RTE from '../components/RTE';
import Search from '../components/Search';
import SearchBox from '../components/SearchBox';
import SearchModule from '../components/SearchModule';
import SectionList from '../components/SectionList';
import SeriesListing from '../components/SeriesListing';
import SimpleCardList from '../components/SimpleCardList';
import SitecoreJssForm from '../components/SitecoreJssForm';
import Spacer from '../components/Spacer';
import SpecialOffers from '../components/SpecialOffers';
import SplitGallery from '../components/SplitGallery';
import SplitGalleryContainer from '../components/SplitGalleryContainer';
import SplitModule from '../components/SplitModule';
import StockFeed from '../components/StockFeed';
import Stories from '../components/Stories';
import SubscribeForm from '../components/SubscribeForm';
import TabList from '../components/TabList';
import TestNoParams from '../components/TestNoParams';
import TestWithParams from '../components/TestWithParams';
import TextDropdown from '../components/TextDropdown';
import TextModule from '../components/TextModule';
import TimerBanner from '../components/TimerBanner';
import TwoColumn from '../components/TwoColumn';
import VerticalNavBar from '../components/VerticalNavBar';
import VideoPlayer from '../components/VideoPlayer';

const components = new Map();
components.set('AccordionList', AccordionList);
components.set('AccordionMultiplePDF', AccordionMultiplePDF);
components.set('Advisor', Advisor);
components.set('BrandPortfolio', BrandPortfolio);
components.set('Breadcrumb', Breadcrumb);
components.set('CardCarousel', CardCarousel);
components.set('CardGrid', CardGrid);
components.set('CardGridContacts', CardGridContacts);
components.set('CardLink', CardLink);
components.set('CardList', CardList);
components.set('CardListExtra', CardListExtra);
components.set('CardModuleFull', CardModuleFull);
components.set('CarouselCardHighlights', CarouselCardHighlights);
components.set('CollapsibleTextModule', CollapsibleTextModule);
components.set('ColumnCard', ColumnCard);
components.set('ContactCards', ContactCards);
components.set('ContentHubSeriesDetails', ContentHubSeriesDetails);
components.set('ContentHubSeriesOverview', ContentHubSeriesOverview);
components.set('ContentHubSpecialOffers', ContentHubSpecialOffers);
components.set('CookiePolicyBanner', CookiePolicyBanner);
components.set('CustomHtmlComponent', CustomHtmlComponent);
components.set('DataTableCNHComponent', DataTableCNHComponent);
components.set('Disclaimer', Disclaimer);
components.set('DownloadList', DownloadList);
components.set('DropDown', DropDown);
components.set('Events', Events);
components.set('ExploreEquipment', ExploreEquipment);
components.set('ExternalComponent', ExternalComponent);
components.set('FindADealer', FindADealer);
components.set('Footer', Footer);
components.set('GenericCTAList', GenericCTAList);
components.set('Header', Header);
components.set('HeroBanner', HeroBanner);
components.set('HeroCarousel', HeroCarousel);
components.set('Highlights', Highlights);
components.set('HistoryModule', HistoryModule);
components.set('IconButton', IconButton);
components.set('IFrame', IFrame);
components.set('KeepInTouch', KeepInTouch);
components.set('LanguageDropdown', LanguageDropdown);
components.set('LanguageSelector', LanguageSelector);
components.set('LightWeightHeader', LightWeightHeader);
components.set('LinkList', LinkList);
components.set('ModelsListing', ModelsListing);
components.set('NavigationFilterCardList', NavigationFilterCardList);
components.set('NavigationLinkList', NavigationLinkList);
components.set('NewsletterConfirmation', NewsletterConfirmation);
components.set('PageTitle', PageTitle);
components.set('PrivacyBanner', PrivacyBanner);
components.set('PrivacyBottomBanner', PrivacyBottomBanner);
components.set('PrivacyFilter', PrivacyFilter);
components.set('PrivacyForm', PrivacyForm);
components.set('PrivacyStatement', PrivacyStatement);
components.set('PrivacyStatementV2', PrivacyStatementV2);
components.set('ProductIntro', ProductIntro);
components.set('Redirectww1Component', Redirectww1Component);
components.set('RelatedLinks', RelatedLinks);
components.set('RTE', RTE);
components.set('Search', Search);
components.set('SearchBox', SearchBox);
components.set('SearchModule', SearchModule);
components.set('SectionList', SectionList);
components.set('SeriesListing', SeriesListing);
components.set('SimpleCardList', SimpleCardList);
components.set('SitecoreJssForm', SitecoreJssForm);
components.set('Spacer', Spacer);
components.set('SpecialOffers', SpecialOffers);
components.set('SplitGallery', SplitGallery);
components.set('SplitGalleryContainer', SplitGalleryContainer);
components.set('SplitModule', SplitModule);
components.set('StockFeed', StockFeed);
components.set('Stories', Stories);
components.set('SubscribeForm', SubscribeForm);
components.set('TabList', TabList);
components.set('TestNoParams', TestNoParams);
components.set('TestWithParams', TestWithParams);
components.set('TextDropdown', TextDropdown);
components.set('TextModule', TextModule);
components.set('TimerBanner', TimerBanner);
components.set('TwoColumn', TwoColumn);
components.set('VerticalNavBar', VerticalNavBar);
components.set('VideoPlayer', VideoPlayer);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
